import React from 'react';

export default function DocumentValidationWorkflowHeader() {
  return (
    <div>
      <h1 className="text-2xl font-bold">Workflow Validasi Dokumen</h1>
      <p className="text-gray-500">Review dan validasi dokumen dari semua modul</p>
    </div>
  );
}
